import React from 'react'
import { withRouter } from 'react-router-dom'
import { Tabs } from 'antd'
const { TabPane } = Tabs
import DayTable from './component/dayTable/dayTable'
import MonthTable from './component/monthTable/monthTable'
import VoidTable from './component/voidTable/voidTable'
import './index.css'

class ClubServiceRecord extends React.Component {
  state = {
    key: '1',
  }
  componentDidMount() {}

  callback = (key) => {
    this.setState({ key })
  }

  render() {
    return (
      <Tabs activeKey={this.state.key} onChange={this.callback}>
        <TabPane tab="按日查看" key="1">
          <DayTable />
        </TabPane>
        <TabPane tab="月度统计" key="2">
          <MonthTable />
        </TabPane>
        <TabPane tab="作废记录" key="3">
          <VoidTable />
        </TabPane>
      </Tabs>
    )
  }
}

export default withRouter(ClubServiceRecord)



// WEBPACK FOOTER //
// ./src/containers/ClubServiceRecord/index.js